export enum MenuSectionEnum {
  COMPANY_PRODUCTS = 'company_products',
  ACTIVITY = 'activity',
  PERFORMANCE = 'performance',
  PERSONAL = 'personal',
  MARKETING = 'marketing',
  SUPPORT = 'support',
  RRHH = 'rrhh',
  COMERCIAL = 'comercial',
  PRODUCTION = 'production',
  DIRECTION = 'direction',
  CONFIGURATION = 'configuration',
  INFO = 'info',
}
